import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
} from "reactstrap";
import { NavLink } from "react-router-dom";

const MyNavbar = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Navbar
        className="px-4 shadow-lg"
        fixed="top"
        expand="md"
        light
        style={{ backgroundColor: "#CA3666", color: "white" }}
      >
        <NavbarBrand href="/" className="text-light">
          <h3
            className=" fw-bold mt-2 logo"
            style={{ color: "rgb(100, 0, 0)" }}
          >
            AML
          </h3>
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto " navbar>
            <NavItem>
              <NavLink className="nav-link text-light" to="/">
                Home
              </NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              {/* OXYGEN CONCENTRATOR */}
              <DropdownToggle nav caret className="text-light">
                Products
              </DropdownToggle>
              <DropdownMenu right className="m-0 p-0 ">
                {/* MEDICAL EQUIPMENTS */}
                <p className="p-2 alert-danger p-0 m-0 text-center  ">
                  Medical Devices
                </p>
                <DropdownItem>
                  <NavLink className="nav-link" to="/lsfg_navi">
                    LSFG-NAVI
                  </NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink className="nav-link" to="/tpm_02">
                    TPM-02
                  </NavLink>
                </DropdownItem>

                <p className="p-2 alert-danger p-0 m-0 text-center  ">
                  Alkaline purifier
                </p>
                <DropdownItem>
                  <NavLink className="nav-link" to="/ao_ct_w">
                    Counter Top
                  </NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink className="nav-link" to="/ao_wm_w">
                    Wall Mount
                  </NavLink>
                </DropdownItem>
                <p className="p-2 alert-danger p-0 m-0 text-center  ">
                  Oxygen Concentrators
                </p>
                <DropdownItem>
                  <NavLink className="nav-link" to="/ze5w">
                    ZE-5W 5lpm
                  </NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink className="nav-link" to="/zm5w">
                    ZM-5W 5lpm
                  </NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink className="nav-link" to="/canta">
                    Canta V8 8lpm
                  </NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink className="nav-link" to="/zy10zw">
                    ZY-10ZW 10lpm{" "}
                  </NavLink>
                </DropdownItem>

                {/* OXYGEN GENERATOR */}
                {/*<p className="p-2 alert-danger p-0 m-0 text-center  ">
                  Oxygen Generators
                </p>
                <DropdownItem>
                  <NavLink className="nav-link" to="/zmj10b">
                    ZYJ-10ZB 10ltm{" "}
                  </NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink className="nav-link" to="/zmj20b">
                    ZYJ-20B 20ltm{" "}
                  </NavLink>
                </DropdownItem>*/}

                {/* AIR PURIFIER */}
                <p className="p-2 alert-danger p-0 m-0 text-center  ">
                  Air Purifiers
                </p>
                <DropdownItem>
                  <NavLink className="nav-link" to="/air_ozone">
                    Plazma & Ozone Purifier{" "}
                  </NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink className="nav-link" to="/air_big">
                    Air Sterilizer{" "}
                  </NavLink>
                </DropdownItem>

                {/* SMART MASK */}
                <p className="p-2 alert-danger p-0 m-0 text-center  ">
                  Aura Mask
                </p>
                <DropdownItem>
                  <NavLink className="nav-link" to="/smart_mask">
                    Aura Smart Mask{" "}
                  </NavLink>
                </DropdownItem>

              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem>
              <NavLink className="nav-link text-light" to="/about">
                About Us
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink className="nav-link text-light" to="/contact">
                Contact Us
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default MyNavbar;